import { errorPathTransform } from 'app2/views/shared/error';

export const upsertCoursesErrorTransform = errorPathTransform('vendorId', 'vendor');
